import React, { useState } from 'react'
import './SubscribeForm.css'

const BlogSubscribeForm = () => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState('')

    const fetchCsrfToken = async () => {
        const response = await fetch('/api/csrf-token/', {
            method: 'GET',
            credentials: "same-origin", // include cookies in the request
        });

        if (response.ok) {
            const data = await response.json();
            return data.csrfToken; // Return the CSRF token
        } else {
            console.error('Failed to fetch CSRF token');
            return null;
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault() // prevent default form submission

        const csrfToken = await fetchCsrfToken();
        if (!csrfToken) return;

        try {
            // Send to your Django Mailjet endpoint with "fountainn" as industry
            const response = await fetch('/api/subscribe/', {
                method: 'POST',
                credentials: "same-origin",
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify({
                    email,
                    industry: 'fountainn'
                }),
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.error || 'Subscription failed')
            }

            setSubmitted(true)
            setError('')
            setEmail('')

            setTimeout(() => setSubmitted(false), 6000) // reset confirmation

        } catch (err: any) {
            console.error(err)
            setError(err.message || 'Something went wrong.')
        }
    }

    return (
        <div className="blog-subscribe-wrapper">
            {submitted ? (
                <div className="thank-you-message">
                    <h1>Thank you for subscribing!</h1>
                </div>
            ) : (
                <form id="sub-form" onSubmit={handleSubmit} className="my-sub-form">

                    <div className='blog-mini-div'>
                        <h1>Discover More, Think Deeper</h1>
                        <p>Go beyond the headlines with educational posts, engaging life topics, and insightful
                            videos curated by the FNN team.</p>
                    </div>

                    <div className="sub-form-items-and-text">
                        <div className="sub-form-items">
                            {/* Email */}
                            <div className="sub-form-block">
                                <input
                                    className="subs-input"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Submit Button */}
                            <button
                                className="subs-submit-button"
                                type="submit"
                            >
                                Send
                            </button>
                        </div>

                        <p>Join our Blog Newsletter to explore the ideas shaping resilience, climate tech, and the
                            people shaping tomorrow.</p>
                    </div>

                    {error && <p className="error-message">{error}</p>}
                </form>
            )}
        </div>
    )
}

export default BlogSubscribeForm
